import React, { Component } from 'react';

class Analytics extends Component {
    render() {
        return (
            <div>
                Analytics
            </div>
        );
    }
}

export default Analytics;